import { render, staticRenderFns } from "./sundry-receipt.vue?vue&type=template&id=731f442c"
import script from "./sundry-receipt.vue?vue&type=script&lang=js"
export * from "./sundry-receipt.vue?vue&type=script&lang=js"
import style0 from "./sundry-receipt.vue?vue&type=style&index=0&id=731f442c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports